export default function hamburgerMenu() {
  const ham = document.getElementById("hamburger-menu");

  ham.addEventListener("click", () => {
    document.getElementById("masthead").classList.toggle("mb-active");
  });
}
